import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsFinanceEfficiency(companyId, query) {
	return dataTransferWrap(
		ModulesMap.REPORTS_FINANCE_EFFICIENCY,dtConfig[ModulesMap.REPORTS_FINANCE_EFFICIENCY].getReportsFinanceEfficiency,
		{
			urlParams: {
				companyId: companyId,
			},
			params: query,
		},
	)
}

export default {
	getReportsFinanceEfficiency,
}
